define('errors/network-error',[],function() {

	function NetworkError(message) {
		Error.apply(this, arguments);
		this.name = "Network Error";
		this.friendlyMessage = message;
	}

	NetworkError.prototype = Object.create(Error.prototype);
	NetworkError.prototype.constructor = NetworkError;

	return NetworkError;
});

